import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { NgbNav, NgbNavItem, NgbNavItemRole, NgbNavLink, NgbNavLinkBase, NgbNavContent, NgbNavOutlet } from '@ng-bootstrap/ng-bootstrap/nav';
import { DashboardSubjectUxComponent } from '../dashboard-subject-ux/dashboard-subject-ux.component';
import { SpinnerComponent } from '../../../shared/spinner/spinner.component';
import { TimePipe } from '../../../shared/pipes/time.pipe';

@Component({
    selector: 'app-dashboard-ux',
    templateUrl: './dashboard-ux.component.html',
    styleUrls: ['./dashboard-ux.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NgbNav, NgbNavItem, NgbNavItemRole, NgbNavLink, NgbNavLinkBase, NgbNavContent, DashboardSubjectUxComponent, NgbNavOutlet, SpinnerComponent, TimePipe]
})
export class DashboardUxComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
